<template>
  <section class="menu" id="menu">
    <div class="container-fluid">
      <div class="row justify-content-lg-around px-4">
        <!-- Image -->
        <div class="col-md-6 col-lg-5 mt-3 mt-lg-0">
          <img
            class="menu-img d-none d-md-block"
            src="@/assets/images/png/nachos.png"
            alt="Nachos" />
        </div>
        <!-- Text -->
        <div class="menu-info col-md-6 align-self-lg-center text-center">
          <div class="info">
            <h2 class="headline">Nuestro menú</h2>
            <div class="row">
              <p class="mt-4">
                Fusionamos los sabores y texturas más exóticos de México para
                ofrecer sabrosos platillos, coctelería y el mejor mezcal.
              </p>
            </div>
            <a
              v-if="link"
              class="btn btn-primary mt-3 mt-lg-4"
              rel="noopener"
              :href="link"
              target="_blank"
              >Ver menú
            </a>
            <button
              v-if="!link"
              class="btn btn-primary mt-lg-4"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#sucursalesLinks"
              v-on:click="buttonClicked('menu')">
              Ver menú
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'Menu',
    created() {},
    data() {
      return {};
    },
    props: {
      sucursal: String,
      link: String,
    },
    methods: {
      buttonClicked: function (button) {
        // console.log('Section log:' + button);
        this.$emit('click', button);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .menu {
    padding-top: 70px;
    margin: auto;
    max-width: 1200px;
  }
  @media (min-width: 425px) {
    .menu {
      &-info {
        .row {
          max-width: 320px;
          margin: auto;
        }
      }
    }
  }
  @media (min-width: $tablet-width) {
    .menu {
      [alt='Nachos'] {
        max-width: 150%;
        left: -50%;
        position: relative;
      }
    }
  }
  @media (min-width: $desktop-width) {
    .menu {
      padding-top: 15%;
      &-info {
        .row {
          max-width: 450px;
        }
      }
    }
  }
  @media (min-width: $desktop-lg-width) {
    .menu {
      margin-top: -10%;
      padding-top: 0;
      [alt='Nachos'] {
        max-width: 200%;
        left: -100%;
      }
    }
  }
</style>
